// @flow
import { MODULARUI_STATUS } from "../constants/Constants";

import type { ReduxStore, ReduxState } from "../redux/types";

/**
 */
const noLoading = (state: ReduxState) =>
  Object.keys(state.modularui).filter(
    (key) => state.modularui[key].status === MODULARUI_STATUS.LOADING,
  ).length === 0;

/**
 */
const loadingCounter = (state: ReduxState) =>
  Object.keys(state.modularui).filter(
    (key) => state.modularui[key].status === MODULARUI_STATUS.LOADING,
  ).length;

/**
 */
const createSSRComplete = (
  store: ReduxStore,
  render: Function,
): Promise<string> => {
  let loadingCount = loadingCounter(store.getState());
  let html = "<div>Nothing to render</div>";

  return new Promise((resolve, reject) => {
    const unsubscribe = store.subscribe(() => {
      const previousCount = loadingCount;
      loadingCount = loadingCounter(store.getState());

      if (previousCount !== loadingCount && noLoading(store.getState())) {
        try {
          html = render();
        } catch (error) {
          reject(error);
          return;
        }

        if (noLoading(store.getState())) {
          unsubscribe();
          resolve(html);
        }
      }
    });

    try {
      html = render();
    } catch (error) {
      reject(error);
      return;
    }

    if (noLoading(store.getState())) {
      unsubscribe();
      resolve(html);
    }
  });
};

export default createSSRComplete;
